const experienceFormValidation = values => {
  const errors = {}
  if (values.permissions?.users) {
    values.permissions.users.map((user, index) => {
      if (user?.first_name || user?.last_name) {
        if (user?.email === "" || !user?.email) {
          errors.permissions = {
            users: {
              ...errors.permissions?.users,
              [`${index}`]: { email: "Required" },
            },
          }
        }
      }
      if (
        user?.email &&
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(user?.email)
      ) {
        errors.permissions = {
          users: {
            ...errors.permissions?.users,
            [`${index}`]: { email: "Invalid email address" },
          },
        }
      }
    })
  }

  return errors
}

export default experienceFormValidation
